export const COURSE_TRANSFER = '/course/transfer/' as const
export const COURSE_TRANSFER_INFO = `${COURSE_TRANSFER}info` as const
export const COURSE_TRANSFER_COURSES = `${COURSE_TRANSFER}courses` as const
